import type { QueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'

export function invalidateCalendarQueries(
  queryClient: QueryClient,
  calendarId: string
) {
  queryClient.invalidateQueries({
    queryKey: queryKeys.calendars.detail(calendarId),
  })
  queryClient.invalidateQueries({
    queryKey: queryKeys.calendars.grid(calendarId),
  })
  queryClient.invalidateQueries({ queryKey: queryKeys.calendars.all })
}
